/**
 * Navbar for the landing page
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import React, { useMemo, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Button } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Navbar from 'client/shared/js/components/Navbar'
import RouteMap from 'common/configs/routeMap'
import styles from './LandingNav.module.scss'

const NAV_ITEMS = [{
  title: 'Explore',
  link: `${RouteMap.explore.url}${RouteMap.explore.trips}`,
  anchor: true
}]

const LandingNav = ({
  className,
  container,
  fluid,
  maps
}) => {
  const [isScrolled, setScrolled] = useState(false)
  const navigate = useCallback((url) => {
    window.location = url
  }, [])

  const handleScroll = useCallback((scrolled) => {
    setScrolled(scrolled)
  }, [])

  const searchBtn = useCallback(({ className, onClick }) => (
    <Button color='light' className={cx(styles['search-btn-class'], 'btn-sm flat', className)} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'magnifying-glass']} className='font-inherit font-small' />
      <span className={styles['search-text']}>Search</span>
    </Button>
  ), [])

  const navProps = useMemo(() => {
    return {
      className: cx(className, styles['landing-nav'], {
        'scrolling-nav': isScrolled,
        [styles['scrolling-nav']]: isScrolled
      }),
      container,
      fluid,
      maps,
      url: null,
      color: 'transparent',
      logoSrc: `/static/assets/img/logos/brand/default.svg`,
      navigate: navigate,
      onScrollCheckpoint: handleScroll,
      disableFixedPadding: true,
      searchable: true,
      searchDestination: true,
      searchBtn: searchBtn,
      collapsible: true,
      anchor: true,
      navItems: NAV_ITEMS,
      btnOptions: [{
        type: 'login',
        color: 'link',
        className: cx(styles['login-btn'], 'dark bold')
      }, {
        type: 'signup',
        color: isScrolled ? 'primary' : 'dark'
      }]
    }
  }, [className, container, isScrolled, navigate, handleScroll, searchBtn, fluid, maps])

  return (
    <Navbar {...navProps} />
  )
}

LandingNav.propTypes = {
  className: PropTypes.string,
  container: PropTypes.bool,
  fluid: PropTypes.bool,
  maps: PropTypes.object
}

export default LandingNav
